module.exports = __webpack_public_path__ + "img/manda_039.9f43466f.png";